import IconAvatar from "@/components/icons/IconAvatar.vue";
import IconDelete from "@/components/icons/IconDelete.vue";
import IconRvHookup from "@/components/icons/IconRvHookup.vue";
import { h } from "vue";
import { createVuetify, type IconProps, type IconSet } from "vuetify";
import { mdi } from "vuetify/iconsets/mdi";
import "vuetify/styles";

const customSvgNameToComponent: any = {
  deleteIcon: IconDelete,
  avatar: IconAvatar,
  rvHookup: IconRvHookup,
};

const customSVGs: IconSet = {
  component: (props: IconProps) =>
    h(customSvgNameToComponent[props.icon as string]),
};

const myCustomLightTheme = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#ffffff",
    "surface-bright": "#FFFFFF",
    "surface-light": "#EEEEEE",
    "surface-variant": "#424242",
    "on-surface-variant": "#EEEEEE",
    primary: "#f97316",
    "primary-darken-1": "#e06609",
    primary20: "#feefe3",
    primary40: "#FEE3D0",
    "on-primary": "#fafaf9",
    gray400: "#a3a3a3",
    gray20: "#d9d9d9",
    secondary: "#1959c2",
    "secondary-darken-1": "#0047bb",
    error: "#f44336",
    info: "#2196F3",
    success: "#00965e",
    warning: "#ed924e",
  },
  variables: {
    "border-color": "#e7e5e4",
    "border-opacity": 0.12,
    "high-emphasis-opacity": 0.87,
    "medium-emphasis-opacity": 0.6,
    "disabled-opacity": 0.38,
    "idle-opacity": 0.04,
    "hover-opacity": 0.04,
    "focus-opacity": 0.12,
    "selected-opacity": 0.08,
    "activated-opacity": 0.12,
    "pressed-opacity": 0.12,
    "dragged-opacity": 0.08,
    "theme-kbd": "#212529",
    "theme-on-kbd": "#FFFFFF",
    "theme-code": "#F5F5F5",
    "theme-on-code": "#202020",
  },
};

export default createVuetify({
  icons: {
    defaultSet: "mdi",
    sets: {
      mdi,
      custom: customSVGs,
    },
  },
  theme: {
    defaultTheme: "myCustomLightTheme",
    themes: {
      myCustomLightTheme,
    },
  },
});
